import { AxiosInstance } from 'axios'
import { clientId, clientSecret } from '@/config'
import LocalStorage from '@/utils/LocalStorage'
import { STORE_AUTH_TOKEN, STORE_IMPERSONATE, STORE_USER } from '@/AppKeys'
import { UserRepository } from '../user/UserRepository'
import { User } from '../user/User'

export class AuthService {

  currentUser: User | null = null
  private userRepository: UserRepository = new UserRepository()

  constructor (
    private api: AxiosInstance
  ) {
    // Check if we have user already
    this.currentUser = LocalStorage.user
  }

  public login (username: string, password: string) {
    const payload = {
      grant_type: 'password',
      client_id: clientId,
      client_secret: clientSecret,
      username: username,
      password: password
    }
    return new Promise(async (resolve, reject) => {
      try {
        const res = await this.api.post('/oauth/token', payload) as any
        LocalStorage.set(STORE_AUTH_TOKEN, res.data.access_token)
        // Also reqest me after login
        this.currentUser = await this.userRepository.me()
        return resolve(this.currentUser)
      } catch (e) {
        return reject(e)
      }
    })
  }

  async refresh () {
    try {
      const res = await this.userRepository.me()
      console.log('Refresh successfull', this.currentUser)
      // The user might be logged out while me is in pending state
      if (this.currentUser) {
        this.currentUser = res
        LocalStorage.set(STORE_USER, this.currentUser)
      }

    } catch (error) {
      this.logout()
    }
  }

  async impersonate (slug: string) {
    try {
      const res = await this.api.post(`impersonate/${slug}`)

      /*
      // Temporaty disable terms chek
      if (!res.data['is_latest_terms_accepted']) {
           throw Error("Artist hasn't accepted the latest terms.");
         }
         */

      // Also reqest me after login
      LocalStorage.set(STORE_AUTH_TOKEN, res.data.access_token)
      this.currentUser = await this.userRepository.me()

      // Same impersonate to localstorage to display a message to admin
      LocalStorage.set(STORE_IMPERSONATE, { slug: slug })

      return Promise.resolve(this.currentUser)
    } catch (error) {
      throw error
    }
  }

  async submitNewTerms (userId: string, payload: any) {
    try {
      return await this.api.post(`users/${userId}/terms`, payload)
    } catch (error) {
      throw error
    }
  }

  async addToFavorite (modelType: 'artwork' | 'artist', modelId: string) {
    try {
      return await this.api.post(`favorites`, { model_id: modelId, model_type: modelType })
    } catch (error) {
      throw error
    }
  }

  async removeFavorite (id: string) {
    try {
      return await this.api.delete(`favorites/${id}`)
    } catch (error) {
      throw error
    }
  }

  async removeSubscription (subscriptionId: string) {
    return await this.api.delete(`subscriptions/${subscriptionId}`)
  }

  resetPassword (email: string) {
    return this.api.post('password/reset', { email: email })
  }

  logout () {
    this.currentUser = null
    LocalStorage.remove(STORE_AUTH_TOKEN)
    LocalStorage.remove(STORE_USER)
  }

}
